"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializedComponentFunctionsMapSchema = exports.ISerializedComponentFunctionStateSchema = void 0;
const zod_1 = require("zod");
const ISerializedTraversal_1 = require("../FunctionalModels/ISerializedTraversal");
const IComponentResource_1 = require("../FunctionalModels/IComponentResource");
exports.ISerializedComponentFunctionStateSchema = zod_1.default.object({
    moduleName: zod_1.default.string(),
    componentName: zod_1.default.string(),
    resourceConsumption: zod_1.default.record(zod_1.default.string(), IComponentResource_1.ComponentResourceFunctionConsumptionSchema),
    functionAssignments: zod_1.default.record(zod_1.default.string(), ISerializedTraversal_1.ISerializedComponentFunctionAssignmentSchema),
});
exports.SerializedComponentFunctionsMapSchema = zod_1.default.record(zod_1.default.string(), exports.ISerializedComponentFunctionStateSchema);
//# sourceMappingURL=ComponentFunctionStatesSerialized.js.map